module.exports = __webpack_public_path__ + "img/timestudy-3.bdf745b4.png";